import React from 'react'
import classes from './footer.module.css'

export default function Footer() {
  return (
    <footer>
        <section>
        <h1 className={classes.ftitle}>
            Feel <br /> <span> the floor</span>
        </h1>
        </section>
        <section>
            <div className={classes.icons}>
                <div>
                    <a className={classes.mail} href='mailto: comex@yukallc.com'>comex@yukallc.com</a>
                </div>

            </div>
        </section>
    </footer>
  )
}
